export default {
  recommended: 'Recommended',
  daily: 'Trending Today',
  weekly: 'Weekly Hits',
  latest: 'Newest',
  oneplus: 'OnePlus Community'
}